import { render, staticRenderFns } from "./ModalInactiveItems.vue?vue&type=template&id=50f9c371&lang=pug&"
import script from "./ModalInactiveItems.vue?vue&type=script&lang=js&"
export * from "./ModalInactiveItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports